import { useEffect, useState } from "react";
import { getConfig } from "./api";

// Module-level cache so we only hit /api/config once per page-load across all
// components that render a price.
let _cache = null;
let _promise = null;

const FALLBACK = {
    regular_paise: 149900,
    current_paise: 99900,
    is_launch: false,
    paid_count: 0,
    slots_total: 0,
    slots_left: 0,
    event_packs: [
        { events: 1, price_paise: 39900, images: 4 },
        { events: 2, price_paise: 69900, images: 8 },
        { events: 3, price_paise: 99900, images: 12 },
        { events: 4, price_paise: 129900, images: 16 },
        { events: 5, price_paise: 149900, images: 20 },
    ],
    individual_event_paise: 39900,
    default_pack_size: 3,
};

async function loadPricing() {
    if (_cache) return _cache;
    if (!_promise) {
        _promise = getConfig()
            .then((cfg) => {
                _cache = cfg?.pricing || FALLBACK;
                return _cache;
            })
            .catch(() => {
                _cache = FALLBACK;
                return _cache;
            });
    }
    return _promise;
}

/** React hook returning the current launch pricing state.
 * Returns FALLBACK immediately on first render, then swaps in the real value once fetched. */
export function usePricing() {
    const [state, setState] = useState(_cache || FALLBACK);
    useEffect(() => {
        let alive = true;
        loadPricing().then((p) => {
            if (alive && p) setState(p);
        });
        return () => {
            alive = false;
        };
    }, []);
    return state;
}

/** Format a paise integer as "₹1,499". */
export function formatINR(paise) {
    if (typeof paise !== "number" || isNaN(paise)) return "";
    return "₹" + Math.round(paise / 100).toLocaleString("en-IN");
}
